import { ButtonProps } from '@design-system/button';
import { Typography } from '@design-system/typography';
import React, { FC } from 'react';

import { CarouselButtonsBlock } from './carousel-buttons-block';

interface CarouselControllersProps {
  isHideControls: boolean;
  progressIndicator: 'caption' | 'none' | 'rails' | 'thumbs' | 'dots';
  buttonNext: ButtonProps;
  buttonPrev: ButtonProps;
  caption?: string;
  totalItems: number;
  activeSlide: number;
  scrollClassName?: string;
  isAtBeginning: boolean;
  isAtEnd: boolean;
  onNextSlide: () => void;
  onPrevSlide: () => void;
}

const noScriptStyles = `
  .swiper-scrollbar {
    display: none;
  }
  .cds-carousel__button-group {
    display: none;
  }
`;

export const CarouselControllers: FC<CarouselControllersProps> = ({
  progressIndicator,
  isHideControls,
  caption,
  buttonNext,
  buttonPrev,
  totalItems,
  activeSlide,
  scrollClassName,
  isAtBeginning,
  isAtEnd,
  onNextSlide,
  onPrevSlide,
}) => (
  <div
    className={`cds-carousel__controllers cds-carousel__controllers--${progressIndicator}`}
  >
    {progressIndicator === 'caption' && (
      <div className="cds-carousel__caption-block">
        <Typography
          tag="span"
          variant="body"
          size="xs"
          content={`${activeSlide + 1}/${totalItems} ${caption || ''}`}
          className="cds-carousel__caption-content"
        />
      </div>
    )}

    {progressIndicator === 'rails' && (
      <div className={`swiper-scrollbar ${scrollClassName}`} />
    )}

    {progressIndicator === 'dots' && (
      <div className="cds-carousel__dots-placeholder" />
    )}

    <CarouselButtonsBlock
      buttonNext={buttonNext}
      buttonPrev={buttonPrev}
      isHideControls={isHideControls}
      isAtBeginning={isAtBeginning}
      isAtEnd={isAtEnd}
      onNextSlide={onNextSlide}
      onPrevSlide={onPrevSlide}
    />
    <noscript>
      <style>{noScriptStyles}</style>
    </noscript>
  </div>
);
